import { combineReducers } from "redux";
import { conditates } from "./canditates";

export default combineReducers({ conditates });
